//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useContext, useState } from 'react';

// === STYLE / MATERIAL UI ===
import {
  Alert,
} from '@mui/material';

// === COMPONENTS ===
import { TaskList      } from './components/TaskList/index';
import { AuditTaskList } from './components/AuditTaskList/index';

// === HOOKS ===
import { useTaskCancel } from 'components/useTaskCancel';
import { useTaskStatus } from 'components/hooks/useTaskStatus/index';

// === API ===
import { returnTask } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function TaskDashboard() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const task_info   = useTaskStatus();
  const cancel_data = useTaskCancel();

  const [ alert_visible  , setAlertVisible  ] = useState( false );
  const [ alert_message  , setAlertMessage  ] = useState( '' );
  const [ alert_severity , setAlertSeverity ] = useState( 'info' );

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if( !cancel_data?.id ) return;

    returnTask();

    setAlertMessage ( cancel_data.message );
    setAlertSeverity( 'warning' );
    setAlertVisible ( true ) ;
  }, [cancel_data]);

  useEffect( () => {

  }, [task_info] );

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( task_info.has_task ) return null; 

    return (
      <>
        { displayAlert() }
        <     TaskList />
        <AuditTaskList />
      </>
    )
  }

  //-----------------------------------------------------------------
  function displayAlert() {
    //-----------------------------------------------------------------
    if( !alert_visible ) return null;
    
    return (
      <Alert variant="outlined" severity={alert_severity} onClose={() => { setAlertVisible( false ) }}>
        {alert_message}
      </Alert>
    )
  }

  //#endregion

  return display();
}